import styled from 'styled-components';

const cobalt = 'var(--primary-blue, #0B4598)';
const coral = 'var(--primary-main, #FB7672)';
const green = 'var(--success-main, #13CA82)';
const surface = 'var(--common-white-main, #ffffff)';
const text = 'var(--text-primary, #1d2b3a)';
const divider = 'var(--divider, #d9e2ef)';

export const MomentPanel = styled.section<{ $warning?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border: 1px solid ${({ $warning }) => ($warning ? coral : divider)};
  border-radius: 12px;
  background: ${({ $warning }) => ($warning ? 'var(--Pink-50, #fff4f3)' : surface)};
  color: ${text};
  overflow-wrap: anywhere;

  h2 {
    margin: 0 0 12px;
    font-size: 22px;
    line-height: 1.25;
  }

  p, li {
    font-size: 16px;
    line-height: 1.5;
  }
`;

export const ActionRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 20px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const ActionButton = styled.button<{ $secondary?: boolean }>`
  min-height: 48px;
  border-radius: 8px;
  border: 2px solid ${cobalt};
  padding: 10px 14px;
  background: ${({ $secondary }) => ($secondary ? surface : cobalt)};
  color: ${({ $secondary }) => ($secondary ? cobalt : surface)};
  font: inherit;
  font-weight: 700;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid ${green};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

export const LinkButton = styled.button`
  border: 0;
  padding: 0;
  background: transparent;
  color: ${cobalt};
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
`;

export const Preview = styled.pre`
  margin: 16px 0;
  padding: 16px;
  border-radius: 8px;
  background: var(--background-info, #f5f7fa);
  color: ${text};
  font-family: inherit;
  font-size: 16px;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

export const ChipList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0;
  list-style: none;

  li {
    border-radius: 999px;
    padding: 4px 10px;
    background: var(--background-success, #eef3fa);
  }
`;

export const FeedbackPanel = styled.section`
  margin-top: 12px;
  color: ${text};

  p {
    margin: 0 0 8px;
    font-size: 16px;
  }
`;

export const FeedbackActions = styled.div`
  display: flex;
  gap: 8px;

  button {
    min-width: 44px;
    min-height: 44px;
    border: 1px solid ${cobalt};
    border-radius: 8px;
    background: ${surface};
    font-size: 22px;
    cursor: pointer;
  }

  button[aria-pressed='true'] {
    background: var(--writing-assist-feedback-selected, #e7f8f0);
    border-color: ${green};
  }
`;

export const GuidelineList = styled.ul`
  padding-left: 24px;

  li {
    margin-bottom: 14px;
    padding: 8px;
    border-radius: 8px;
  }

  li[aria-current='true'] {
    outline: 2px solid ${coral};
    background: var(--Pink-50, #fff4f3);
  }
`;
